import { render, staticRenderFns } from "./TutorBioBreakCard.vue?vue&type=template&id=fc065cee&scoped=true&"
import script from "./TutorBioBreakCard.vue?vue&type=script&lang=js&"
export * from "./TutorBioBreakCard.vue?vue&type=script&lang=js&"
import style0 from "./TutorBioBreakCard.vue?vue&type=style&index=0&id=fc065cee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc065cee",
  null
  
)

export default component.exports